import {ICommentable, ICommentJson, ICommentJsonComplaint} from "../../../nodeserver/structs/database";
import {
    htmlToBb,
    placeCaretAtEnd,
    removeEmptybb,
    spoilerToBb,
    bbToHtml,
    fetchServer,
    handleFetchError, uploadImage, showNotice, showAskDialog
} from "./helpers/functions.js";
import {ServerApi} from "./api.js";
import JSX from "./helpers/react.js";
import {EditCommentField} from "./models/comments/CommentsBlock.js";
import {linkify, linkifyHTML} from "./helpers/autolinker.js";

declare global {
    function escapeHtml(text: string): string;

    let comments: CommentsBase;
    const commentsLinkWhiteList: string[];
    const linkWhiteList: string[];
}

function Buttons({data, isMod}: { data: ICommentJson, isMod: boolean }) {
    const btns: HTMLElement[] = [];
    if (data.user_id == user_id) {
        if (data.dislikes == 0 && data.likes == 0) btns.push(
            <div className="drop-menu-item edit-comment">Редактировать</div>
        )
        btns.push(
            <div className="drop-menu-item remove-comment">Удалить</div>
        );
    } else {
        if (isMod) {
            btns.push(
                <div className="drop-menu-item moder-remove-comment materiable">Удалить</div>,
                <div className="drop-menu-item moder-add-spoiler materiable" onClick={function () {
                    addSpoilerToComment(this as HTMLElement, data!.id)
                }}>Добавить спойлер</div>
            );
        } else btns.push(
            <div className="drop-menu-item send-claim materiable">Пожаловаться</div>
        );
    }
    return <>{btns}</>;

}

async function addSpoilerToComment(element: HTMLElement, commentId: number) {
    try {
        const $comment = $(element).parents('.comment-block');
        await ServerApi.comments.edit(commentId, {spoiler: true});
        showNotice('Добавил спойлер к комментарию', 'Успех');
        clearCommentAfterModer($comment);
    } catch (e) {
        handleFetchError(e);
    }

}

function HideAnswers({count}: { count: number }) {
    return <><i className="fa fa-caret-up"/> Скрыть ответы (<span>{count}</span>)</>
}

function IsCommentHidden(data: ICommentJson) {
    return data.dislikes - data.likes > 15;
}

function HiddenCommentsButton({data}: { data: ICommentJson }) {
    if (IsCommentHidden(data))
        return (
            <a href="#" className="more-text bordered">Комментарий скрыт из-за низкого рейтинга. Показать?</a>
        );
    return false;

}

function ShowAnswers({count}: { count: number }) {
    return <><i className="fa fa-caret-down"/> Показать ответы (<span>{count}</span>)</>
}

class CommentsBase<T extends ICommentJson = ICommentJson> {
    private offset: number = 0;
    protected skip: number = 0;
    private sort: 'new' | 'nice' | 'old' = 'new';
    private readonly commentParam: string | null;

    constructor() {
        const commentParam = window.location.href.lastIndexOf('comment=');
        this.commentParam = commentParam !== -1 ? window.location.href.substring(commentParam + 8) : null;
    }

    protected getCommentsJson(): Promise<{ comments: T[]; isMod: boolean }> {
        return ServerApi.comments.getList(page_type as ICommentable, page_id!, this.skip, this.sort) as Promise<{
            comments: T[];
            isMod: boolean
        }>
    }

    public async getComments() {
        const moreContainer = $('.more-comments-container');
        if (moreContainer.children().length > 0) {
            if (this.commentParam !== null && this.skip === 0) {
                //TODO: load my comment
                // ajaxData += '&comment=' + this.commentParam;
            }
            try {
                moreContainer.html(<div className="main-button disabled bordered"><i className="loading"/> Загрузка...
                </div>);
                const {comments, isMod} = await this.getCommentsJson();

                const old_scroll: number = $(window).scrollTop()!;
                $('.sort-block.comments-sort').removeClass('hidden');
                const commentsBlock = $('.comments-block');
                if (comments.length === 0 && this.offset === 0) {
                    $('.sort-block.comments-sort').html('Комментариев пока нет!');
                }
                // else $('.sort-block.comments-sort').html('');


                this.offset++;
                this.skip = this.offset * 20;

                for (let com of comments) {
                    this.buildCommentHtml(com, isMod)?.appendTo(commentsBlock);
                    this.hideBigComment($('.comment:last'));
                }
                if (comments.length < 20) {
                    moreContainer.html(<div className="more-comments hidden"/>);
                } else {
                    moreContainer.html(<div className="more-comments main-button bordered">Загрузить ещё</div>);
                }

                $(window).scrollTop(old_scroll);
            } catch (e) {
                handleFetchError(e);
                moreContainer.html(
                    <div className="more-comments main-button load-manyaly bordered">Загрузить комментарии</div>
                );
            }

        }
    }

    public async moreComments(button: HTMLElement, parentCommentId: number) {
        const $btn = $(button);
        if ($btn.hasClass('blocked')) return;
        $btn.addClass('blocked');
        try {
            if (!$btn.hasClass('done')) {
                $btn.html('<i class="loading"></i> Загрузка');
                let skip = ($btn.data('skip') || 0) as number,
                    data = parentCommentId ? (await ServerApi.comments.getChildren(
                        parentCommentId, skip
                    )) : (await ServerApi.comments.getList(
                        page_type as ICommentable,
                        page_id!,
                        skip,
                        'old'
                    ));
                if (data.comments.length > 0) {
                    const children = $btn.parents('.comment-block').find('.comment-children');
                    for (let comm of data.comments) {
                        this.buildCommentHtml(comm as T, data.isMod)?.prependTo(children);
                        this.hideBigComment(children.find('.comment-block:first .comment'));
                    }
                    children.parent().css('max-height', children.outerHeight()!);
                    $btn.addClass('show pressed');
                    $btn.data('skip', skip);
                    // if (skip < +($btn.data('num'))) {
                    //     const left = +($btn.data('num')) - skip;
                    //     $btn.html(`<i class="fa fa-caret-down"></i> Показать ещё (осталось <span>${left}</span>)`);
                    // } else {
                    //     $btn.data('num', children.children().length);
                    $btn
                        .html(<HideAnswers count={$btn.data('num')}/>)
                        .addClass('done');
                    // }
                    if (document.activeElement?.tagName === 'TEXTAREA') {
                        window.scroll({
                            top: children.offset()!.top + children.outerHeight()! - (screen.height / 3),
                            left: 0,
                            behavior: 'smooth'
                        });
                    }
                    await new Promise(r => setTimeout(r, 300));
                    children.parent()
                        .css('overflow', 'visible')
                        .css('max-height', 'none');
                } else {
                    $btn.text('Ответов нет');
                }
            } else {
                const commentBlock = $btn.parents('.comment-block'),
                    children = commentBlock.find('.comment-children');
                if (!$btn.hasClass('show')) {
                    $btn.html(<HideAnswers count={$btn.data('num')! as number}/>);
                    children.parent().css('max-height', children.outerHeight()!);
                    setTimeout(function () {
                        children.parent().css('overflow', 'visible').css('max-height', 'none');
                    }, 400);
                } else {
                    $btn.html(<ShowAnswers count={$btn.data('num')}/>);
                    commentBlock.find('.comment').addClass('no-bottom-border');
                    children.parent().css('max-height', children.outerHeight()!);
                    setTimeout(function () {
                        children.parent().css('overflow', '').css('max-height', 0);
                    }, 0);
                }
                $btn.toggleClass('show');
                await new Promise(r => setTimeout(r, 400));
                // setTimeout(()=> $btn.removeClass('blocked'), 400);
            }
        } catch (e) {
            handleFetchError(e);
        } finally {
            $btn.removeClass('blocked');
        }
    }

    /**
     * Abstract method for generating bottom html elements
     * @param comment
     * @protected
     */
    protected getBottomHtmlButtons(comment: T): Node {
        return document.createTextNode('');
    }

    /**
     * build HTML comment from json model<br>
     * @param data {ICommentJson}
     * @param isMod {boolean} - Is user moderator
     * @private
     */
    private buildCommentHtml(data: T, isMod: boolean): JQuery | null {
        if ($('#comments-tab .comment[data-id=' + data.id + ']').length === 0) {
            const classes = ['comment'];
            if (user_id && user_id == data.user_id) classes.push('my-comment');
            else if (!user_id) classes.push('non-auth');
            if (data.children_count > 0) classes.push('no-bottom-border');

            const html = (
                <div className="comment-block" data-id={data.id} data-username={data.name}>
                    <div className={classes}>
                        <a href={data.item_data?.url ?? `/users/id${data.user_id}`}
                           className={`comment-img bordered${data.item_data ? ' no-height' : ''}`}>
                            <img className="bordered" src={data.item_data?.posters?.big ?? data.avatars.big} style={{
                                '--small': `url(${data.item_data?.posters?.small ?? data.avatars.small})`
                            }} loading="lazy" alt="Avatar"/>
                        </a>
                        <div className="comment-head">
                            <div className="comment-top">
                                <a href={data.item_data?.url ?? `/users/id${data.user_id}`}
                                   className={`comment-author${(data.roles.includes('admin') || data.roles.includes('root')) && !data.item_data ? ' label ' + (data.user_id == 2 ? 'bot' : 'admin') : ''}`}
                                   style={data.roles.includes('root') ? {'--text': '"владелец"'} : {}}>
                                    {data.item_data?.title || data.name}
                                </a>
                                {!!user_id && data.user_id != user_id && !data.item_data &&
                                    <div className="reply-button materiable bordered">Ответить</div>}
                                <local-time className="comment-date" data-time={data.time}></local-time>
                            </div>
                            {!!user_id &&
                                <div className="comment-controls">
                                    <span className="drop-menu-click far fa-fw fa-ellipsis-h"></span>
                                    <div className="hidden-menu invisible">
                                        <div className="drop-list bordered">
                                            <Buttons data={data} isMod={isMod}/>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="comment-body">
                            <div className={`comment-text${IsCommentHidden(data) ? ' hidden' : ''}`}></div>
                            <HiddenCommentsButton data={data}/>
                            {this.getBottomHtmlButtons(data)}
                        </div>
                        <div className="comment-karma">
                            <div>
                                <span
                                    className={`likes ${data.vote == 1 ? 'fas' : 'far'} fa-thumbs-up`}>{data.likes}</span>
                                <span
                                    className={`dislikes ${data.vote == -1 ? 'fas' : 'far'} fa-thumbs-down`}>{data.dislikes}</span>
                            </div>
                            {
                                !!user_id && data.user_id != user_id && !data.item_data &&
                                <div className="reply-button comment-mobile materiable bordered">Ответить</div>
                            }
                        </div>
                    </div>
                    {data.children_count > 0 &&
                        <div className="comment-more-button bordered" data-num={data.children_count}>
                            <ShowAnswers count={data.children_count}/>
                        </div>
                    }
                    {!data.parent_id &&
                        <div className="comment-children-container">
                            <div className="comment-children"></div>
                        </div>
                    }
                </div>);
            const $el = $(html).data('comment', data);
            let text = escapeHtml(data.text).toString()
                .replace(/\n{3,}/g, '<br><br>').replace(/\n/g, '<br>');
            text = bbToHtml(text);
            text = linkifyHTML(text);
            if (data.deleted_at) {
                $el.find('.comment-text').html(
                    <div className="bot-text">Этот комментарий был удален пользователем или администрацией</div>
                );
                if (!isMod && !data.parent_id)
                    $el.css('display', 'none')
            } else $el.find('.comment-text').html(text);


            return $el;
        }
        console.warn('comment already exists - that\'s wierd')
        return null;
    }

    private hideBigComment(comment: JQuery) {
        const text = comment.find('.comment-text:not(.hidden)');
        if (text.length > 0) {
            if ((text.height()! * 3) + (text.width()! / 2) > 750) {
                text.addClass('hide-text hide');
                text.after('</div><a href="#" class="more-text bordered">Показать весь текст</a>')
            }
        }
    }

    public replyTo(button: HTMLDivElement, comment_id: number, user_name: string) {
        const that = $(button);
        if (!that.hasClass('blocked')) {
            that.addClass('blocked');

            const commentField = $('.leave-comment-body-wrapper:first');
            if (commentField.length === 0) {
                return showNotice('Невозможно оставить комментарий', 'Ошибка', 'error');
                // return showNotice('Вы не можете оставлять комментарии пока штраф не будет снят', 'Отправка комментария', 'error')
            }
            const commentBlock = that.parents('.comment-block:last');
            if (commentBlock.find('.leave-comment-body-wrapper').length === 0) {
                commentBlock.append(commentField.clone());
            }
            const leaveComment = commentBlock.find('.leave-comment-body-wrapper');
            const textarea = leaveComment.find('.comment-textarea')
            commentBlock.find('.reply').remove();
            leaveComment.prepend(<div className="reply" data-id={comment_id}>Ответ на сообщение <b>{user_name}</b> <i
                className="remove-reply far fa-times"/></div>);
            let editable = '';
            if (mobileOperatingSystem !== 'Android') {
                editable = ' contenteditable="false"'
            }
            textarea.html('<nick class="nick-label"' + editable + '>' + user_name + '</nick>&nbsp;');
            placeCaretAtEnd(textarea[0]);
            const btn = commentBlock.find('.comment-more-button');
            if (btn.hasClass('done')) {
                btn.addClass('show');
                commentBlock.find('.comment-children').show();
                window.scroll({
                    top: textarea.offset()!.top - (screen.height / 2),
                    left: 0,
                    behavior: 'smooth'
                });
            } else {
                if (!btn.hasClass('pressed'))
                    btn.trigger('click');
            }
            that.removeClass('blocked');
        }
    }

    public async sendComment(
        message: string, $this: JQuery, add_to_post: { reply_to_comment?: number; parent_comment?: number },
        parent_id: number | null, reply_elem: JQuery, parent: JQuery
    ) {
        const brutals = await fetchServer<{ brutals: string[] }>('/js/black_list.json').then(b => b.brutals),
            symbols = /[',', '.', '(', ')', '/', '-']/g,
            text = message.toLowerCase().replaceAll(symbols, ' ').split(' ');
        for (const val of text) {
            if (brutals.includes(val)) {
                showNotice('В вашем комментарии используется нецензурная лексика, которая на сайте запрещена!', 'Ошибка отправки комментария', 'error');
                return false;
            }
        }
        if (!checkAcceptedLinks(message, commentsLinkWhiteList)) {
            $this.removeClass('blocked').html('Отправить');
            return false;
        }

        const data = await ServerApi.comments.addComment(page_type as ICommentable, page_id!, {
            text: message,
            parent_comment: add_to_post.parent_comment,
            reply_to_comment: add_to_post.reply_to_comment
        });
        {
            data.text ??= message;
            data.likes = 0;
            data.dislikes = 0;
            data.parent_id ??= parent_id!;
            data.time = new Date().getTime() / 1000;
            data.name ??= $('#login').text()! as string;
            data.user_id ??= user_id!;
        }
        let html = this.buildCommentHtml(data as T, true);
        if (!html) {
        } else if (reply_elem.length > 0) {
            const commentBlock = $this.parents('.comment-block:last');
            commentResize(commentBlock.find('.comment-children').append(html));
            const moreBtn = commentBlock.find('.comment-more-button');
            if (moreBtn.length > 0) {
                const btnNum = moreBtn.data('num') + 1;
                moreBtn.data('num', btnNum);
                moreBtn.data('skip', (moreBtn.data('skip') || 0) + 1);
                if (!moreBtn.hasClass('pressed') || moreBtn.hasClass('done')) {
                    moreBtn.find('span').html(btnNum);
                }
            } else {
                commentBlock.find('.comment').addClass('no-bottom-border')
                commentBlock.find('.comment-children-container').before(
                    <div className="comment-more-button show pressed done bordered" data-num="1">
                        <HideAnswers count={1}/>
                    </div>
                );
            }
        } else $('.comments-block').prepend(html);
        parent.find('.comment-textarea').html('');
        parent.find('.remove-reply').trigger('click');
        $this.removeClass('blocked').html('Отправить');
        if (Comments.Instance.offset === 0) {
            await Comments.Instance.getComments();
        }
    }

    static Instance: CommentsBase;

    public sortBy(button: HTMLButtonElement, sort: 'new' | 'nice' | 'old') {
        if ($('.more-comments').length > 0) {
            this.offset = 0;
            this.skip = 0;
            this.sort = sort;
            $('.sort-block.comments-sort .sub-menu-inner-container').removeClass('show')
                .find('.default-button').removeClass('active');
            $(button).addClass('active');
            $('.comments-block').html('');
            return this.getComments();
        }
    }


    /**
     * Add like/dislike to comment
     * @param $el  - jquery element
     * @param isLike {boolean} = true if like else false
     * @param isComment {boolean} = false if is review
     */
    public async addVote($el: JQuery, isLike: boolean, isComment: boolean = true) {
        const comment = $el.parents('.comment-block,.one-review');
        if (!user_id)
            return showNotice('Для голосования вы должны быть зарегистрированы', 'Ошибка', 'error');
        if (!comment.hasClass('blocked')) {
            comment.addClass('blocked');
            try {
                const another = isLike ? $el.next() : $el.prev();
                $el.toggleClass('far').toggleClass('fas');
                another.removeClass('fas').addClass('far');
                const isDelete = $el.hasClass('far');
                let dataLikes: { likes: number, dislikes: number };
                if (isDelete) {
                    dataLikes = isComment ? (await ServerApi.comments.removeLike(comment.data('id'))) : (await ServerApi.reviews.removeLike(comment.data('id')));
                    showNotice('Голос удалён', '=_=');
                } else {
                    dataLikes = isComment ? (await ServerApi.comments.addLike(comment.data('id'), isLike)) : (await ServerApi.reviews.addLike(comment.data('id'), isLike));
                    showNotice('Спасибо, Ваш голос учтен');
                }
                if (isLike) {
                    $el.html(dataLikes.likes + "");
                    another.html(dataLikes.dislikes + "");
                } else {
                    $el.html(dataLikes.dislikes + "");
                    another.html(dataLikes.likes + "");
                }
            } catch (e) {
                handleFetchError(e);
                $el.toggleClass('fas').toggleClass('far');
            } finally {
                comment.removeClass('blocked');
            }
        }
    }

    /**
     * Checks if comment string is valid
     * @param message {string}
     */
    static checkOnSend(message: string) {
        if (message.length > 5000)
            return 'Максимальная длина комментария 5000 символов';
        if (message.replace(/\[(?:\/?[жкпз]|\/?спойлер(?:=.+?)?)]/g, "").length < 10)
            return 'Минимальная длина комментария - 10 символов';
        if (/\[спойлер=[^\]]{32,}]/.test(message))
            return 'Максимальная длина заголовка спойлера 30 символов';
        return true;
    }

}

class CommentsComplaint extends CommentsBase<ICommentJsonComplaint> {
    override getBottomHtmlButtons(comment: ICommentJsonComplaint) {
        return (
            <>
                <hr/>
                <p style="text-align: center">
                <span style="color: var(--main-red)">
                    Причина: </span>{escapeHtml(comment.reason.title)} | от <a href={`/users/id${comment.from_user.id}`}
                                                                               target="_blank">пользователя</a>
                    | к <a href={comment.item_data_complain?.url} target="_blank">объекту</a>
                </p>
                <div className="bottom-buttoms bottom-buttons-flex">
                    <button className="main-button cancel-claim bordered">Отклонить</button>
                    <button
                        className={`main-button ${comment.reason.key == 1 ? 'transparent' : 'neutral'} add-spoiler-claim bordered`}>Добавить
                        спойлер
                    </button>
                    <button className="main-button attention remove-claim bordered">Удалить комментарий</button>
                </div>
            </>
        );

    }

    override async getCommentsJson() {
        if (this.skip === 0) return await ServerApi.comments.getClaimedComments();
        return {comments: [], isMod: true};
    }
}

export const Comments = page_type === 'moderator' ? CommentsComplaint : CommentsBase;
// @ts-ignore
window['comments'] = Comments.Instance = new Comments();

$('html')
    .on('click', '.send-comment', async function () {
        const $this = $(this);
        if ($this.hasClass('blocked')) return;
        try {
            await Comments.Instance.getComments();
            $this.addClass('blocked').html('<i class="loading"></i> Отправка');
            const parent = $this.parents('.leave-comment-body-wrapper'),
                parent_id = parseInt($this.parents('.comment-block:last').data('id'));

            const reply_elem = parent.find('.reply');
            const add_to_post: { reply_to_comment?: number; parent_comment?: number } = reply_elem.length > 0 ? {
                reply_to_comment: parseInt(reply_elem.data('id')),
                parent_comment: parent_id
            } : {};
            let message = parent.find('.comment-textarea').html().trim();
            message = htmlToBb(message);
            message = escapeEncode(message);
            message = removeEmptybb(message).trim();
            // var checkMessage = message.replace(/<\/?[^>]+(>|$)/g, "").replace(/\s/g, "").replace(/\u00a0/g, "").replace(/&#39;/g, "");
            let checkMessage = Comments.checkOnSend(message);
            if (checkMessage === true) {
                await Comments.Instance.sendComment(message, $this, add_to_post, parent_id, reply_elem, parent);
            } else {
                $this.removeClass('blocked').html('Отправить');
                showNotice(checkMessage, 'Ошибка отправки комментария', 'error');
            }
        } catch (e) {
            handleFetchError(e);
        } finally {
            $this.removeClass('blocked').html('Отправить');
        }
    })
    .on('click', '#comments .send-edit, .comments-block .send-edit', async function () {
        const $this = $(this);
        if ($this.hasClass('blocked')) return;
        $this.addClass('blocked');
        try {
            const comment = $this.parents('.comment'), id = comment.parents('.comment-block').data('id');
            let text = comment.find('.edit-message').html().trim();

            if (!checkAcceptedLinks(text, commentsLinkWhiteList)) return false;
            text = htmlToBb(text);
            text = escapeEncode(text);
            text = text.replace(/\n{3,}/g, '\n\n');
            let checkMessage = Comments.checkOnSend(text);
            if (checkMessage === true) {
                await ServerApi.comments.edit(id, {text});
                // const spoiler = comment.find('input[name="spoiler"]:checked').length,
                //     send_data = new URLSearchParams({
                //         text: text,
                //     });
                // const data = await fetchServer<{ success: boolean }>(`/comments/${id}`, 'PUT', {
                //     body: send_data
                // });
                text = bbToHtml(text.replace(/\n/g, '<br>'));
                text = linkifyHTML(text);
                comment.removeClass('edit').find('.comment-text').html(text);
                comment.find('.comment-karma, .comment-text, .more-text').show();
                comment.find('.emojis-btn, .comment-menu,.edit-message').remove();
                commentResize(comment);
            } else throw checkMessage;

        } catch (e) {
            handleFetchError(e);
        } finally {
            $this.removeClass('blocked');
        }
    })
    .on('click', '#comments span.likes, .comments-block span.likes', async function () {
        await Comments.Instance.addVote($(this), true);
    })
    .on('click', '#comments span.dislikes, .comments-block span.dislikes', async function () {
        await Comments.Instance.addVote($(this), false);
    })
    .on('click', '.review-block span.likes', async function () {
        await Comments.Instance.addVote($(this), true, false);
    })
    .on('click', '.review-block span.dislikes', async function () {
        await Comments.Instance.addVote($(this), false, false);
    })
    .on('click', '.send-claim', function () {
        const comment = $(this).parents('.comment');
        let html = (<>
            <div className="banned-win">
                <div className="banned-win-close far fa-times-circle"></div>
                <div className="banned-user">Жалоба на комментарий</div>
                <select className="why-delete">
                    <option value="0" data-placeholder="true">Причина</option>
                    <option value="1">спойлер</option>
                    <option value="3">нецензурная лексика</option>
                    <option value="4">оскорбление других участников</option>
                    <option value="5">комментарий не по теме или не имеет смысла</option>
                    <option value="8">ссылка на сторонний сайт</option>
                </select>
                <div className="claim-ok main-button bordered">Отправить</div>
            </div>
            <div className="banned-overlay"></div>
        </>);
        if (comment.find('.banned-win').length < 1) {
            //@ts-ignore
            comment.append(html).find('select.why-delete').slimSelect();
        }
    })
    .on('click', '.claim-ok', async function () {
        //leave a complaint
        const $this = $(this),
            $comment = $this.parents('.comment-block'),
            reason: string = $this.parent().find('.why-delete').val() as string;
        if (+reason) {
            try {
                await ServerApi.comments.claim(+$comment.data('id')!, +reason);
                $comment.find('.banned-win').remove();
                $comment.find('.banned-overlay').remove();
                showNotice('Спасибо, Ваша жалоба отправлена', 'Успех');

            } catch (e) {
                handleFetchError(e);
            }
        } else {
            showNotice('Укажите причину жалобы', 'Ошибка', 'error');
        }
    })
    .on('click', '.remove-comment', async function () {
        if (await showAskDialog('Удалить комментарий?', 'Вы действительно хотите удалить этот комментарий? Это действие нельзя будет отменить')) {
            const $this = $(this),
                id = $this.parents('.comment-block').data('id');
            try {
                await ServerApi.comments.remove(id);
                // const json = await fetchServer<{ success: true; }>(`/comments/${id}`, 'DELETE');
                if ($this.parents('.comment-children').length !== 0) {
                    var btn = $this.parents('.comment-children-container').prev();
                    var btnNum = btn.data('num') - 1;
                    btn.data('num', btnNum);
                    if (btnNum > 0) {
                        btn.find('span').html(btnNum + '');
                    } else $this.fadeOut();
                    commentResize($this);
                }
                $this.parents('.comment-block:first').fadeOut();
            } catch (e) {
                handleFetchError(e);
            }
        }
    })
    .on('click', '.edit-comment', function () {
        const that = $(this),
            comment = that.parents('.comment');
        if (comment.hasClass('edit')) return;
        comment.addClass('edit');

        comment.find('.comment-karma, .comment-text, .more-text').hide();
        comment.find('.comment-text a').contents().unwrap();
        let text = comment.find('.comment-text').html();
        // const html = '<div><div class="comment-textarea edit-message" data-placeholder="Текст комментария" contenteditable="true">' + text + '</div><div class="comment-menu"><div class="bbcode"> <div class="default-button bb-b" data-bb="bold"> <i class="far fa-fw fa-bold"></i> </div> <div class="default-button bb-i" data-bb="italic"> <i class="far fa-fw fa-italic"></i> </div> <div class="default-button bb-u" data-bb="underline"> <i class="far fa-fw fa-underline"></i> </div> <div class="default-button bb-s" data-bb="strikethrough"> <i class="far fa-fw fa-strikethrough"></i> </div> <div class="default-button bb-spoiler" data-bb="spoiler"> <i class="far fa-fw fa-low-vision"></i> </div></div><div><button class="main-button send-edit col">Сохранить</button><button class="main-button transparent send-cancel col">Отмена</button></div> </div></div>';

        comment.find('.comment-body').after(<EditCommentField text={spoilerToBb(text)} isEdit={true}/>);
        commentResize(that);
        if (comment.hasClass('spoiler-comment'))
            comment.find('input[type=checkbox]').prop('checked', true);
    })
    .on('click', '.comment .reply-button', function () {
        const comment = $(this).parents('.comment-block');
        Comments.Instance.replyTo(this, comment.data('id'), comment.data('username'))
    })
    .on('click', '.comment-more-button', async function () {
        const comment = $(this).parents('.comment-block');
        await comments.moreComments(this, +comment.data('id'));
    })
    .on('click', '.send-cancel', function () {
        const comment = $(this).parents('.comment').removeClass('edit');
        comment.find('.comment-karma, .comment-text, .more-text').show();
        comment.find('.emojis-btn, .comment-menu,.edit-message').remove();
        const text = comment.find('.comment-text');
        text.html(linkifyHTML(text[0].innerHTML));
        commentResize(comment)
    })
    .on('click', '.remove-reply', function () {
        const parent = $(this).parents('.leave-comment-body-wrapper');
        parent.remove();
    })
    .on('paste', '.comment-textarea:not(.review-text)', function (e) {
        e.preventDefault();
        // @ts-ignore
        const text = e!.originalEvent!.clipboardData!.getData('text/plain');
        document.execCommand('inserttext', false, text);
    })
    .on('click', '.spoiler-button', function () {
        const $this = $(this);
        $this.hide();
        $this.next().css('display', 'initial');
        commentResize($this)
    })
    .on('click', 'spoiler', function () {
        const $this = $(this);
        $this.hide();
        $this.prev().css('display', 'initial');
        commentResize($this);
        try {
            navigator.vibrate(100)
        } catch (e) {
            console.error(e);
        }
    })
    .on('click', '.moder-remove-comment,.remove-claim', function () {
        const comment = $(this).parents('.comment');
        let html = (
            <>
                <div className="banned-win">
                    <div className="banned-win-close far fa-times-circle"></div>
                    <div className="banned-user">Удалить комментарий</div>
                    <select className="why-delete">
                        <option value="0" data-placeholder="true">Причина</option>
                        <option value="1">спойлер</option>
                        <option value="3">нецензурная лексика</option>
                        <option value="4">оскорбление других участников</option>
                        <option value="5">комментарий не по теме или не имеет смысла</option>
                        <option value="8">ссылка на сторонний сайт</option>
                        <option value="7">комментарий, на который Вы отвечали, был удален</option>
                    </select>
                    <label className="checkbox"><input name="remove_children" type="checkbox" value="1"/>
                        <div></div>
                        Удалить дочерние</label>
                    <br/><label className="checkbox"><input name="forever" type="checkbox" value="0"/>
                    <div></div>
                    Удалить НАВСЕГДА</label>
                    <div className="remove-ok main-button bordered">Удалить</div>
                </div>
                <div className="banned-overlay"></div>
            </>
        );
        if (comment.find('.banned-win').length < 1) {
            comment.append(html).find('.why-delete').slimSelect();
        }
    })
    .on('click', '.remove-ok', async function () {
        const $this = $(this),
            comment = $this.parents('.comment-block').eq(0),
            reason = comment.find('.why-delete').val() as string;
        if (+reason) {
            const data = {
                reason: +reason,
                remove_children: 0,
                forever: +comment.find('[name="forever"]').is(':checked')
            }
            if (comment.find('[name="remove_children"]').is(':checked')) {
                data.remove_children = 1;
            }
            comment.find('.banned-win, .banned-overlay').remove();
            try {
                const response = await ServerApi.comments.remove(+comment.data('id')!, data);
                comment.find('.comment-body').append('<div class="attention-text">Комментарий скрыт</div>')
                comment.find('.drop-list').append('<div class="drop-menu-item moder-restore-comment">Восстановить</div>')
                comment.find('.moder-viewed-comment, .moder-remove-comment').remove()

            } catch (e) {
                handleFetchError(e);
            }
        } else {
            showNotice('Укажите причину удаления', 'Ошибка', 'error');
        }
    })
    .on('click', '.moder-restore-comment', async function () {
        const $this = $(this);
        const parent = $this.parents('.comment-block');
        if (confirm('Вы уверены, что хотите восстановить комментарий?')) {
            try {
                await ServerApi.comments.restore(+parent.data('id'));
                if (parent.find('.moder-remove-comment').length == 0) {
                    $this.after('<div class="drop-menu-item moder-remove-comment">Удалить</div>');
                }
                $this.remove()
                parent.find('.attention-text').remove();
                showNotice('Комментарий восстановлен', 'Успех', 'success')

            } catch (e) {
                handleFetchError(e);
            }
        }
    })
    .on('click', '.more-text', async function (e) {
        e.preventDefault();
        const $this = $(this);
        const text = $this.parent().find('.hide-text, .comment-text.hidden');
        const startHeight = text.height()

        text.removeClass('hide-text hidden hide');

        const endHeight = text.height();
        text.css('max-height', startHeight + "px");
        text.animate({'max-height': endHeight + "px"}, 300, () => {
            text.css('max-height', '');
            commentResize(text);
        })
        $this.remove();
    })
    .on('click', '.more-comments,.li-show-comments', () => Comments.Instance.getComments())
    .on('click', '.sort-comments-btn', function () {
        Comments.Instance.sortBy(this, $(this).data('by') as 'new' | 'old' | 'nice');
    })
    .on('click', '.add-spoiler-claim', async function () {
        try {
            const $comment = $(this).parents('.comment-block');
            const id = $comment.data('id')! as number;
            await ServerApi.comments.edit(id, {spoiler: true});
            showNotice('Добавил спойлер к комментарию', 'Успех');
            clearCommentAfterModer($comment);
        } catch (e) {
            handleFetchError(e);
        }
    })
    .on('click', '.cancel-claim', async function () {
        try {
            const $comment = $(this).parents('.comment-block');
            const id = $comment.data('id')! as number;
            await ServerApi.comments.removeClaim(id);
            showNotice('Удалил заявку', 'Успех');
            clearCommentAfterModer($comment);
        } catch (e) {
            handleFetchError(e);
        }

    })
    .on('click', '.comments-block .banned-win-close', function () {
        $(this).parents('.comment').find('.banned-overlay').remove();
        $(this).parents('.comment').find('.banned-win').remove();
    })
    .on('change', '.comments-block .why-delete', function () {
        const id = $(this).find('option:selected').data('id');
        if (id == 'admin_comment') {
            $(this).parent().find('.custom').html('<input name="admin_comment" type="text" placeholder="Свой комментарий">');
        } else {
            $(this).parent().find('.custom').html('');
        }
    });

function clearCommentAfterModer($element: JQuery) {
    $element.fadeOut().promise().done(() => $element.remove());
}

function checkAcceptedLinks(text: string, array?: string[]) {
    // if (!array) {
    //     array = linkWhiteList
    // }
    // let checkLink = true;
    // const linksHTML = linkify.find(text);
    // for (const el of linksHTML) {
    //     if (!new RegExp(array.join('|')).test(el.value)) {
    //         checkLink = false;
    //         break;
    //     }
    // }
    // if (!checkLink) {
    //     showNotice('В комментариях запрещены все ссылки на сторонние сайты, за исключением ' + array.slice(1).join(', '), 'Ошибка отправки комментария', 'error');
    //     return false;
    // }
    return true;
}

function escapeEncode(text?: string) {
    if (text) {
        return text
            .replace(/&nbsp;/g, ' ')
            .replace(/&amp;/g, '&')
            .replace(/&gt;/g, '>')
            .replace(/&lt;/g, '<');
    } else {
        return '';
    }
}

function commentResize(that: JQuery) {
    var childs = that;
    if (!childs.hasClass('comment-children')) {
        childs = childs.parents('.comment-children');
    }
    childs.parent().css('overflow', '').css('max-height', childs.outerHeight()!);
    setTimeout(function () {
        childs.parent().css('overflow', 'visible').css('max-height', 'none');
    }, 300);
}

// $(()=> {});
